import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageSkeleton from './PageSkeleton';
import {
  isExplicitMarketingHome,
  resolveLoggedInInvestorHomeRedirect,
} from '../utils/loggedInInvestorHome';

interface LoggedInInvestorHomeProps {
  children: React.ReactNode;
}

/** Logged-in investors skip marketing home/investor landing and go to the dashboard. */
const LoggedInInvestorHome: React.FC<LoggedInInvestorHomeProps> = ({ children }) => {
  const { user, firebaseUser, loading, userLoading } = useAuth();
  const location = useLocation();

  let cachedUserType: string | null = null;
  if (firebaseUser) {
    try {
      cachedUserType = localStorage.getItem(`prairi_ut_${firebaseUser.uid}`);
    } catch {
      cachedUserType = null;
    }
  }

  const target = resolveLoggedInInvestorHomeRedirect({
    authLoading: loading,
    userLoading,
    firebaseUid: firebaseUser?.uid ?? null,
    userType: user?.userType,
    cachedUserType,
    explicitHome: isExplicitMarketingHome(location.search),
  });

  if (target === 'wait') return <PageSkeleton />;
  if (target === '/dashboard') return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};

export default LoggedInInvestorHome;
